import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import * as tracking from 'dibs-tracking';
import { connect } from 'react-redux';
import { getBuyerId } from 'dibs-cookie-jar';
import { cdnTestTracking } from '../utils/tracking/searchBrowse/cdnTestTracking';

class SharedTrackingContainerComponent extends React.Component {
    static getDerivedStateFromProps(newProps, prevState) {
        const visitCount = newProps.visitCount > prevState.visitCount ? newProps.visitCount : '';
        const skuId = newProps.skuId !== prevState.skuId ? newProps.skuId : '';

        if (visitCount || skuId) {
            return {
                skuId: skuId || prevState.skuId,
                visitCount: visitCount || prevState.visitCount,
                trackingInitialized: false,
            };
        }

        return null;
    }

    constructor() {
        super();
        this.state = {
            trackingInitialized: false,
            visitCount: 0,
            skuId: undefined,
        };
    }

    componentDidMount() {
        const userId = getBuyerId(document.cookie);
        /**
         * No user id on mount? Means the user is logged out and we can safely fire off tracking.
         */
        if (!userId && this.shouldFireTracking(this.props)) {
            this.fireTracking();
        }
    }

    componentDidUpdate() {
        if (this.shouldFireTracking()) {
            this.fireTracking();
        }
    }

    fireTracking() {
        const { onTrackingFired, additional } = this.props;
        let gtmPageInfo = this.props.gtmPageInfo;

        if (additional) {
            const currentAdditional = gtmPageInfo?.additional || {};

            const sessionPageCount = tracking.getSessionPageCount();
            //This is required to match the value since when using pagination, sessionPageCount increment gets called after the event is fired
            const pageCountViewed = this.state.visitCount ? sessionPageCount + 1 : sessionPageCount;

            gtmPageInfo = {
                ...gtmPageInfo,
                additional: {
                    ...currentAdditional,
                    ...additional,
                    ...cdnTestTracking(),
                    pageCountViewed,
                },
            };
        }
        tracking.trackPageview(gtmPageInfo);
        this.setState({
            trackingInitialized: true,
        });
        onTrackingFired();
    }

    shouldFireTracking() {
        /**
         * if we're fetching user but have no user data, wait until that returns before
         * firing tracking
         */

        const { fetchUser, user, isClient, gtmPageInfo, isMultiSku, skuId } = this.props;

        const waitingForUserData = fetchUser && !user;
        const waitingForSkuId = isMultiSku && !skuId;
        return (
            !waitingForUserData &&
            !waitingForSkuId &&
            gtmPageInfo &&
            !this.state.trackingInitialized &&
            isClient
        );
    }

    render() {
        return null;
    }
}

SharedTrackingContainerComponent.propTypes = {
    onTrackingFired: PropTypes.func,
    relay: PropTypes.object.isRequired,
    user: PropTypes.object,
    gtmPageInfo: PropTypes.object,
    isClient: PropTypes.bool.isRequired,
    fetchUser: PropTypes.bool.isRequired,
    currency: PropTypes.string.isRequired,
    visitCount: PropTypes.number,
    additional: PropTypes.object,
    skuId: PropTypes.string,
    isMultiSku: PropTypes.bool,
};

SharedTrackingContainerComponent.defaultProps = {
    onTrackingFired: () => {},
    visitCount: 0,
};

function mapStateToProps(state) {
    const {
        relayVariables: { variables },
    } = state;
    return {
        isClient: variables.isClient,
        fetchUser: variables.fetchUser,
    };
}

export const SharedTrackingContainer = createFragmentContainer(
    connect(mapStateToProps)(SharedTrackingContainerComponent),
    {
        user: graphql`
            fragment SharedTrackingContainer_user on User {
                serviceId
                isVerifiedTrade
            }
        `,
    }
);
